export default "__VITE_ASSET__64662506__"